import { arrayFlags } from "../../../../constantes/constantes";
import Title from "./title";
import CardGeneral from "../cardGeneralComponent/cardGeneral";
import CardFormula1 from "../cardF1Component/cardFormula1";
import CardTenis from "../cardTenisComponent/cardTenis";
import CardBaseball from "../cardBaseballComponent/cardBaseball";

/**
 * Componente que renderiza el contenido específico de cada deporte
 * Selecciona automáticamente el componente de tarjeta apropiado según el tipo de deporte
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.sport - Datos del deporte
 * @param {string} props.sport.sport_code - Código del deporte (MTR=Motor, TNS=Tenis, otros=General)
 * @param {string} props.sport.name - Nombre del deporte
 * @param {Array} props.sport.leagues - Array de ligas con sus juegos
 * @param {string} props.pathIframe - URL del iframe (no utilizada actualmente)
 * @param {string} props.selectedLeague - Liga seleccionada (null = todas)
 * 
 * @returns {JSX.Element} Contenedor con título y tarjeta específica del deporte
 */
export default function SportContentHomeRender({ sport, mostrarBotonApostar, patrocinador, mostrarMomios, selectedLeague }) {

  // Configuración de banderas y opciones
  const ocultarApostarTenis = false;
  const namePatrocinador = "strendus";
  const isStrendus = String(patrocinador).toLowerCase() !== String(namePatrocinador) ? false : true;
  const showMomios = mostrarMomios === 'true' ? true : false;

  /**
   * Determina si el deporte tiene juegos en vivo
   * Busca en todas las ligas si algún juego tiene la clase "clarosports-in-progress-game"
   */
  const hasLiveGames = sport.leagues.some((league) => {
    if (Array.isArray(league.games) && league.games.length > 0) {
      return league.games.some(
        (game) => String(game.class).toLowerCase().trim() === "clarosports-in-progress-game"
      );
    }
    return false;
  });

  /**
   * Obtiene el código del deporte en mayúsculas para comparación
   */
  const sportCode = String(sport.sport_code).toUpperCase();

  /**
   * Propiedades comunes para todos los componentes de tarjetas
   */
  const commonCardProps = {
    leagues: sport.leagues,
    mostrarMomios: showMomios,
    url: "/assets/",
    mostrarBotonApostar,
    isStrendus,
    selectedLeague
  };

  /**
   * Renderiza el componente de tarjeta apropiado según el tipo de deporte
   */
  const renderSportCard = () => {
    switch (sportCode) {
      case "MTR": // Motor/Fórmula 1
        return <CardFormula1 {...commonCardProps} isTenis={false} />;

      case "TNS": // Tenis
        return (
          <CardTenis
            {...commonCardProps}
            flags={arrayFlags}
            isTenis={true}
            ocultarApostarTenis={ocultarApostarTenis}
          />
        );

      case 'FOOT': // Deportes FUTBOL
        return <CardGeneral {...commonCardProps} isTenis={false} />;

      default: // Deportes BASEBALL, FUT AMERICANO , BASKETBALL
        return <CardBaseball {...commonCardProps} isTenis={false} />;
    }
  };

  return (
    <div className="container-home-event">
      {/* Título del deporte con indicador de juegos en vivo - se oculta si hay liga seleccionada */}
      {!selectedLeague && (
        <Title
          sport={sport}
          hasLiveGames={hasLiveGames}
        />
      )}

      {/* Contenedor de la lista de eventos del deporte */}
      {
        <div className="container-home-list">
          {renderSportCard()}
        </div>
      }
    </div>
  );
}